import { arrayOrEmpty } from '@src/utils/array'

export const getSortOrder = (ordered, all) => {
	const existing = arrayOrEmpty(ordered).filter((id) => all.includes(id))
	const add = arrayOrEmpty(all)
		.filter((id) => !existing.includes(id))
		.reverse()
	return [...add, ...existing]
}
